import { useEffect, useRef } from "react";
import { useStore } from "reactflow";
import useObserverNodeSize from "../../custom-hooks/useObserverNodeSize";

const ObserverWrapper = ({ children, id, xPos, yPos, className, parentNodeId }) => {
  const triggerNodeChanges = useStore(state => state.triggerNodeChanges);

  const elementRef = useRef(null);
  const heightRef = useRef(0);
  const yRef = useRef(yPos);
  const {
    size: { width, height },
  } = useObserverNodeSize(elementRef);

  useEffect(() => {
    if (!parentNodeId) {
      if (heightRef.current === 0) {
        heightRef.current = height;
      } else if (heightRef.current !== height) {
        const newYPef = yRef.current + (heightRef.current - height) / 2;
        yRef.current = newYPef;
        heightRef.current = height;
        triggerNodeChanges([
          {
            id,
            type: "position",
            position: {
              x: xPos,
              y: newYPef,
            },
          },
          {
            id,
            type: "dimensions",
            updateStyle: true,
            resizing: true,
            dimensions: {
              width: width,
              height: height,
            },
          },
        ]);
        setTimeout(() => {
          triggerNodeChanges({
            id: id,
            type: "dimensions",
            resizing: false,
          });
        }, 1000);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height, parentNodeId]);

  return (
    <div className={className} ref={elementRef}>
      {children}
    </div>
  );
};

export default ObserverWrapper;
